export default __webpack_public_path__ + "static/bannerPubli-PR-ce7079b5230b8f8d2166c88f9084e868.png";